module.exports = __webpack_public_path__ + "img/scheduled-publishing.948dabb.jpg";